import { logout } from '@topconagriculture/auth';
import { createReducer } from '@topconagriculture/frontend-utils';
import * as dotProp from 'dot-prop-immutable';
import { fetchUserApps, fetchUserPermissions, getCompany, getProfile, setUserProfileLoaded, retryMutationOnCompany, retryMutationOnCompanySelectedRule, retryMutationOnCompanyCancel, fetchTenantsSettings, } from './profiling.actions';
export const initialState = {
    company: null,
    userProfile: null,
    userProfileLoaded: false,
    userApps: null,
    retryMutationOnCompany: false,
    tenantsSettings: null,
};
const profilingReducer = createReducer(initialState, {
    [getProfile.done.type]: (state, action) => {
        return dotProp.set(state, 'userProfile', { ...state.userProfile, ...action.payload.result });
    },
    [fetchUserPermissions.done.type]: (state, action) => {
        return dotProp.set(state, 'userProfile.permissions', action.payload.result);
    },
    [getCompany.done.type]: (state, action) => {
        const company = action.payload.result;
        return dotProp.set(state, 'company', { ...state.company, ...company });
    },
    [setUserProfileLoaded.type]: (state, action) => {
        return dotProp.set(state, 'userProfileLoaded', action.payload);
    },
    [fetchUserApps.done.type]: (state, action) => {
        return dotProp.set(state, 'userApps', action.payload.result || []);
    },
    [logout.done.type]: (state) => {
        return dotProp.set(state, 'userProfileLoaded', false);
    },
    [fetchTenantsSettings.done.type]: (state, action) => {
        return dotProp.set(state, 'tenantsSettings', action.payload.result || []);
    },
    [retryMutationOnCompany.type]: (state) => dotProp.set(state, 'retryMutationOnCompany', true),
    [retryMutationOnCompanySelectedRule.type]: (state) => dotProp.set(state, 'retryMutationOnCompany', false),
    [retryMutationOnCompanyCancel.type]: (state) => dotProp.set(state, 'retryMutationOnCompany', false),
});
export default { profiling: profilingReducer };
//# sourceMappingURL=profiling.reducer.js.map